<template>
  <div class="verify-credit-card-container"></div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'

export default {
  name: 'CreditCardVerify',
  props: ['omise_token'],
  mounted() {
    this.verifyOmiseTokenCreditCard(this.omise_token)
  },
  methods: {
    ...mapActions(['verifyOmiseTokenCreditCard']),
  },
}
</script>

<style lang="scss">
.verify-credit-card-container {
  display: none;
}
</style>
